export const publish_type = [
    {value: '', label: ''},
    {value: 'Publier', label: 'Publier '},
    {value: 'Planifier', label: 'Planifier'},
    {value: 'Brouillon', label: 'Brouillon'},
]